import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "lifeBuoy"
const LifeBuoyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.347 19.883A8.96 8.96 0 0 1 12 21a8.959 8.959 0 0 1-4.347-1.117l2.94-2.94c.036-.037.07-.075.103-.115a5.007 5.007 0 0 0 2.608 0c.032.04.067.078.104.115l2.939 2.94Zm3.535-3.536A8.96 8.96 0 0 0 21 12a8.959 8.959 0 0 0-1.117-4.347l-2.94 2.94a1.515 1.515 0 0 1-.115.103 5.006 5.006 0 0 1 0 2.608c.04.032.079.067.115.104l2.94 2.939ZM4.117 7.653A8.96 8.96 0 0 0 3 12a8.96 8.96 0 0 0 1.117 4.347l2.94-2.94a1.52 1.52 0 0 1 .115-.103 5.006 5.006 0 0 1 0-2.608 1.465 1.465 0 0 1-.115-.104l-2.94-2.939Zm3.536-3.535A8.96 8.96 0 0 1 12 3a8.96 8.96 0 0 1 4.347 1.117l-2.94 2.94a1.465 1.465 0 0 0-.103.115 5.005 5.005 0 0 0-2.608 0 1.52 1.52 0 0 0-.104-.115l-2.939-2.94Zm7.886 10-1.42 1.42a.49.49 0 0 0-.004.698l3.548 3.549c.186.186.504.19.698-.004l1.42-1.42a.49.49 0 0 0 .004-.698l-3.549-3.548a.498.498 0 0 0-.697.003ZM4.219 5.64l1.42-1.42a.498.498 0 0 1 .698-.004l3.548 3.549a.49.49 0 0 1-.003.697l-1.42 1.42a.498.498 0 0 1-.698.004L4.215 6.337a.49.49 0 0 1 .004-.698Zm3.545 8.476-3.549 3.548a.498.498 0 0 0 .004.698l1.42 1.42a.49.49 0 0 0 .698.004l3.548-3.549a.498.498 0 0 0-.003-.697l-1.42-1.42a.49.49 0 0 0-.698-.004Zm6.351-6.351 3.548-3.549a.49.49 0 0 1 .698.004l1.42 1.42c.194.194.19.512.004.698l-3.549 3.548a.49.49 0 0 1-.697-.003l-1.42-1.42a.498.498 0 0 1-.004-.698Z"
      />
    </svg>
  )
}
export default LifeBuoyIcon
